import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state:{
        flag:0
    },
    mutations:{
        changeInfo(state,item){
            state.flag = item
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js